<dx-popup
  [width]="'530px'"
  [(visible)]="showModal"
  [height]="'auto'"
  [showTitle]="false"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
>
  <div *dxTemplate="let data of 'content'">
    <div class="popup-content">
        <h1 class="title">{{ "SUBSCRIPTIONS.DISCONNECT-SUBSCRIPTION.TITLE" | translate }}</h1>
        <p class="description">{{ "SUBSCRIPTIONS.DISCONNECT-SUBSCRIPTION.TEXT" | translate }}</p>
        <div class="button-container">
        <dx-button 
            [text]="'COMMON.CANCEL' | translate" 
            type="normal"
            stylingMode="contained"
            [width]="'190px'"
            (onClick)="cancel()"
        ></dx-button>
        <dx-button 
            [text]="'SUBSCRIPTIONS.DISCONNECT-SUBSCRIPTION.DISCONNECT' | translate" 
            type="danger"
            stylingMode="contained"
            [width]="'190px'"
            (onClick)="disconnect()"
        ></dx-button>
        </div>
    </div>
  </div>
</dx-popup>